export default {
  errorLoadingComments: null,
  comments: [],
  currentPage: 1,
  nextPage: null,
  petitionSlug: null
}
